module.exports = __webpack_public_path__ + "static/media/data-icon.4ed5f753.svg";